import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ContactSubmissionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/ContactSubmission/ContactSubmissionBrowser.js")
	}

	render() {
		return (
			<Activity 
				name="ContactSubmission"
				RenderedComponent={this.RenderedComponent}
				context="ContactSubmission"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ContactSubmissionActivity)
